import './Publications.css';
import '../Footer/Footer'
import React, { useState, useEffect } from "react";
import BannerModal from './PublicationModal';
import { getAllDataWithFlag } from "../../../services/CommonService";
import Swal from 'sweetalert2';

function Publications({ publication, projectId }) {
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [message, setMessage] = useState("");
  const [publications, setPublication] = useState([]);
  const [selectedPublicationId, setSelectedPublicationId] = useState(null);
  const [isGridView, setIsGridView] = useState(true);
  const [selectedCard, setSelectedCard] = useState(null);
  const [CountryData, setCountryData] = useState([]);
  const [contentData, setTypeofContent] = useState([]);
  const [StateData, setStateData] = useState([]);
  const [DistrictData, setDistrictData] = useState([]);
  const [typologyData, setTypologyData] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: '', direction: 'asc' });
  const [districtList, setDistrictList] = useState([]);
  const [lookup, setLookup] = useState([]);

  // Search 
  const [searchFilters, setSearchFilters] = useState({
    year: '',
    type: '',
    typology: '',
    district: '',
    state: '',
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSearchFilters((prev) => ({
      ...prev,
      [name]: value,
      ...(name === 'state' && { district: '' }) // reset district if state changes
    }));

    if (name === 'state') {
      const filteredDistricts = DistrictData.filter(
        (district) => district.id_mststate == parseInt(value)
      );
      setDistrictList(filteredDistricts);
    }
  };

  // filter Table
  const filteredPublications = publications.filter((pub) => {
    return (
      (!searchFilters?.year || String(pub?.year || '').includes(searchFilters?.year)) &&
      (!searchFilters?.type || String(pub?.type || '').toLowerCase().includes(searchFilters?.type?.toLowerCase())) &&
      (!searchFilters?.typology || String(pub?.typology || '').toLowerCase().includes(searchFilters?.typology?.toLowerCase())) &&
      (!searchFilters?.district || String(pub?.district || '').toLowerCase().includes(searchFilters?.district?.toLowerCase())) &&
      (!searchFilters?.state || String(pub?.state || '').toLowerCase().includes(searchFilters?.state?.toLowerCase()))
    );
  });
  // Pagination 
  const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(filteredPublications.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentItems = filteredPublications.slice(startIndex, startIndex + itemsPerPage);
  //-------------------------------------------------------//

  useEffect(() => {
    const typologyDa = JSON.parse(localStorage.getItem('lookup') || '[]');
    setLookup(typologyDa);
    const Datacountrystatedistrict = JSON.parse(localStorage.getItem('StateMaster') || '{}');
    if (Datacountrystatedistrict) {
      setCountryData(Datacountrystatedistrict.country || []);
      setStateData(Datacountrystatedistrict.state || []);
      setDistrictData(Datacountrystatedistrict.district || []);
    }
    setTypeofContent(typologyDa.filter((m) => m.Flag == '4'));
    setTypologyData(typologyDa.filter((m) => m.Flag == '3'));
  }, []);
  useEffect(() => {
    if (CountryData.length && StateData.length && DistrictData.length) {
      getAllaData();

    }
  }, [CountryData, StateData, DistrictData]);

  // Get all Master Data
  const getAllaData = async () => {
    try {
      setLoading(true);
      const response = await getAllDataWithFlag(4);
      if (response.status != 200) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = response?.data;
      const PublicationData = data.publication;;
      const activeItems = PublicationData.filter(item => item.is_deleted === null);
      const mergedArray = activeItems.map(item => {
        const matchedCountry = CountryData.find(country => country.id == item.country);
        const matchedState = StateData.find(state => state.id_mststate == item.state);
        const matchedDistrict = DistrictData.find(dis => dis.id_mstdistrict == item.district);
        const matchedTypology = typologyData.find(typo => typo.LookupCode == item.typology);
        return {
          ...item,
          countryName: matchedCountry ? matchedCountry.CountryName : null,
          stateName: matchedState ? matchedState.statename : null,
          districtName: matchedDistrict ? matchedDistrict.districtname : null,
          typologyName: matchedTypology ? matchedTypology.LookupValue : null
        };
      });
      setPublication(mergedArray)
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: error?.response?.data?.message || error?.message,
        icon: "error",
        confirmButtonText: "OK",
      });
      setLoading(false);
    }
  };

  const changePage = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const openImg = (item) => {
    setSelectedCard({ data: item });
    setShowModal(true);
  };

  // sort Table//
  const sortedItems = React.useMemo(() => {
    const sorted = [...currentItems];
    if (sortConfig.key) {
      sorted.sort((a, b) => {
        const aVal = a[sortConfig.key];
        const bVal = b[sortConfig.key];
        if (aVal < bVal) return sortConfig.direction === 'asc' ? -1 : 1;
        if (aVal > bVal) return sortConfig.direction === 'asc' ? 1 : -1;
        return 0;
      });
    }
    return sorted;
  }, [currentItems, sortConfig]);

  const handleSort = (key) => {
    setSortConfig(prev => ({
      key,
      direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc'
    }));
  };

  const handleResetFilters = () => {
    setSearchFilters({
      year: '',
      type: '',
      typology: '',
      state: '',
      district: '',
    });
    setDistrictList([]); // Optional: clear district list if it depends on state
  };

  if (!currentItems?.length) return null;

  return (
    <>
      <div className="project-search-container">
        {!projectId && <div className="top-image">
          {/* You can set background image from CSS */}
        </div>}
        {!projectId && (
          <div className="container p-0">
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <h2 className="title ms-3">Our Publications</h2>
            </div>
            <div className="search-bar-container">
              <select name="year" value={searchFilters.year} onChange={handleInputChange}>
                <option value="">Select Year</option>
                <option value="2023">2023</option>
                <option value="2022">2022</option>
                <option value="2021">2021</option>
                {/* Add more years as needed */}
              </select>
              <select name="type" value={searchFilters.type} onChange={handleInputChange}>
                <option value="">Select Type</option>
                {contentData
                  ?.sort((a, b) => a.LookupValue.localeCompare(b.LookupValue))
                  .map((typo) => (
                    <option key={typo.LookupCode} value={typo.LookupCode}>
                      {typo.LookupValue}
                    </option>
                  ))}
                {/* Add more types as needed */}
              </select>
              <select name="typology" value={searchFilters.typology} onChange={handleInputChange}>
                <option value="">Select Typology</option>
                {typologyData
                  ?.sort((a, b) => a.LookupValue.localeCompare(b.LookupValue))
                  ?.map((typo) => (typo.Flag == 3 ? (
                    <option key={typo.LookupCode} value={typo.LookupCode}>
                      {typo.LookupValue}
                    </option>
                  ) : null
                  ))}
              </select>
              <select name="state" value={searchFilters.state} onChange={handleInputChange}>
                <option value="">Select State</option>
                {StateData
                  ?.sort((a, b) => a.statename.localeCompare(b.statename))
                  ?.map((state) => (
                    <option key={state?.id_mststate} value={state?.id_mststate}>
                      {state?.statename?.trim()}
                    </option>
                  ))}
              </select>
              <select name="district" value={searchFilters.district} onChange={handleInputChange} disabled={!districtList.length}>
                <option value="">Select District</option>
                {districtList.map((district) => (
                  <option key={district.id_mstdistrict} value={district?.districtname?.trim()}>
                    {district.districtname.trim()}
                  </option>
                ))}
              </select>
              <button
                type="button"
                onClick={handleResetFilters}
                className="btn btn-outline-secondary ms-2"
              >
                Reset Filters
              </button>
            </div>
          </div>
        )}

        {projectId && <h2 className="fw-bold mt-2">Publications</h2>}
        <div className="container">
          {!projectId && <div className="row justify-content-end">
            <div className="toggle-container-publication me-4">
              <button
                className={`toggle-option ${!isGridView ? 'active' : ''}`}
                onClick={() => setIsGridView(false)}
              >
                <i className="bi bi-check2-circle me-1"></i>
                <i className="bi bi-list"></i>
              </button>
              <button
                className={`toggle-option ${isGridView ? 'active' : ''}`}
                onClick={() => setIsGridView(true)}
              >
                <i className="bi bi-grid-3x3-gap-fill"></i>
              </button>
            </div>
          </div>}
          {isGridView ? (
            <div className="grid-view">
              {currentItems.map((item, index) => (
                <div className="card publication-card" key={index}>
                  <span onClick={() => openImg(item)} style={{ cursor: "pointer" }}>
                    <i class="bi bi-file-earmark-pdf-fill text-danger" style={{ fontSize: "1.5rem" }} ></i>
                    <i class="bi bi-arrow-down-circle-fill text-warning" style={{ fontSize: "1rem", marginLeft: "-8px" }}></i>
                  </span>
                  <h3>{item.title}</h3>
                  <p style={{ fontSize: "small" }}>{item.typologyName}</p>
                  <div className="tags">
                    <span>{item.countryName}</span>
                    <span>{item.stateName}</span>
                    <span>{item.districtName}</span>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="list-view">
              <table>
                <thead>
                  <tr>
                    <th onClick={() => handleSort('title')} style={{ border: '1px solid #ccc', cursor: 'pointer' }}>Title</th>
                    <th onClick={() => handleSort('typology')} style={{ border: '1px solid #ccc', cursor: 'pointer' }}>Typology</th>
                    <th onClick={() => handleSort('type')} style={{ border: '1px solid #ccc', cursor: 'pointer' }}>Type</th>
                    <th onClick={() => handleSort('countryName')} style={{ border: '1px solid #ccc', cursor: 'pointer' }}>Country</th>
                    <th onClick={() => handleSort('stateName')} style={{ border: '1px solid #ccc', cursor: 'pointer' }}>State</th>
                    <th onClick={() => handleSort('districtName')} style={{ border: '1px solid #ccc', cursor: 'pointer' }}>District</th>
                    <th onClick={() => handleSort('year')} style={{ border: '1px solid #ccc', cursor: 'pointer' }}>Year</th>
                    <th style={{ border: '1px solid #ccc' }}>Download</th>
                  </tr>
                </thead>
                <tbody>
                  {sortedItems.map((proj, index) => (
                    <tr key={index}>
                      <td style={{ border: '1px solid #ccc' }}>{proj.title}</td>
                      <td style={{ border: '1px solid #ccc' }}>{proj.typologyName}</td>
                      <td style={{ border: '1px solid #ccc' }}>{lookup && lookup?.find(m => (m.Flag === '4' && m.LookupCode === proj.type))?.LookupValue}</td>
                      <td style={{ border: '1px solid #ccc' }}>{proj.countryName}</td>
                      <td style={{ border: '1px solid #ccc' }}>{proj.stateName}</td>
                      <td style={{ border: '1px solid #ccc' }}>{proj.districtName}</td>
                      <td style={{ border: '1px solid #ccc' }}>{proj.year}</td>
                      <td> <span onClick={() => openImg(proj)} style={{ cursor: "pointer" }}>
                        <i class="bi bi-file-earmark-pdf-fill text-danger" style={{ fontSize: "1.5rem" }} ></i>
                        <i class="bi bi-arrow-down-circle-fill text-warning" style={{ fontSize: "1rem", marginLeft: "-8px" }}></i>
                      </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
        {!projectId && <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', marginTop: '20px' }}>
          <button onClick={() => changePage(currentPage - 1)} disabled={currentPage === 1}>
            &lt;
          </button>
          {[...Array(totalPages)].map((_, index) => {
            const page = index + 1;
            return (
              <button
                key={page}
                onClick={() => changePage(page)}
                style={{
                  fontWeight: currentPage === page ? 'bold' : 'normal',
                  color: currentPage === page ? '#2e1e82' : 'black',
                  border: '1px solid gray',
                  padding: '5px 10px',
                  cursor: 'pointer',
                }}
              >
                {page}
              </button>
            );
          })}

          <button onClick={() => changePage(currentPage + 1)} disabled={currentPage === totalPages}>
            &gt;
          </button>
        </div>}
        <BannerModal show={showModal} onClose={() => setShowModal(false)} data={selectedCard} />
      </div>
    </>
  )
}

export default Publications;